@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;700&display=swap');
@import "tailwindcss";
@plugin "@tailwindcss/typography";

@font-face {
  font-family: 'S-Core Dream';
  src: url('/fonts/SCDream4.otf') format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'S-Core Dream';
  src: url('/fonts/SCDream7.otf') format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'MaruBuri';
  src: url('/fonts/MaruBuri-Regular.otf') format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'MaruBuri';
  src: url('/fonts/MaruBuri-Bold.otf') format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

:root {
  /* ── Brand Colors ── */
  --color-primary:          #2E1F63;
  --color-secondary:        #8B87B0;
  --color-accent:           #F7D667;

  /* ── Background ── */
  --color-bg:               #12122A;
  --color-surface:          #1E1E2F;

  /* ── Border ── */
  --color-border-default:   #2F2F45;
  --color-border-accent:    #F7D567;

  /* ── Text ── */
  --color-text-primary:     #F5F5F7;
  --color-text-secondary:   #B9B8C7;
  --color-text-tertiary:    #7A7A8F;
  --color-text-disabled:    #4A4A5A;

  /* ── System / State ── */
  --color-error:            #E31100;
  --color-success:          #04B014;

  /* ── Typography ── */
  --font-korean:            'S-Core Dream', sans-serif;
  --font-english:           'Space Grotesk', sans-serif;
  --font-brand:             'MaruBuri', serif;
  --letter-spacing-base:    -0.025em;

  /* ── Spacing (8pt 기반) ── */
  --spacing-xs:    4px;
  --spacing-sm:    8px;
  --spacing-md:    16px;
  --spacing-lg:    24px;
  --spacing-xl:    32px;
  --spacing-2xl:   48px;
  --spacing-3xl:   64px;
}

html {
  font-size: 17px;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--font-korean);
  background-color: var(--color-bg);
  color: var(--color-text-primary);
  letter-spacing: var(--letter-spacing-base);
}

/* 영문/숫자는 Space Grotesk 적용 */
input, button, code, pre, .font-mono {
  font-family: var(--font-english), var(--font-korean);
}

#root {
  min-height: 100vh;
}

@keyframes fade-in {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}
.animate-fade-in {
  animation: fade-in 0.2s ease-out;
}

/* 영수증 점선 */
.receipt-divider {
  border: none;
  border-top: 2px dashed var(--color-border-default);
}
